function openModalMaterialDialog() {
    let button = null
    if(activeProject.isNorthAmericanSteel) {
        button = document.getElementById('steel-material-tab')
        $('a[href="#steel-material-tab-pane"]').tab('show')
    } else if(activeProject.isASTMSteel) {
        button = document.getElementById('astm-steel-material-tab')
        $('a[href="#astm-steel-material-tab-pane"]').tab('show')
    } else if(activeProject.isEuropeanSteel) {
        button = document.getElementById('european-steel-material-tab')
        $('a[href="#european-steel-material-tab-pane"]').tab('show')
    } else if(activeProject.isWood) {
        button = document.getElementById('wood-material-tab')
        $('a[href="#wood-material-tab-pane"]').tab('show')
    } else if(activeProject.isEngineeredLumber) {
        button = document.getElementById('wood-material-tab')
        $('a[href="#wood-material-tab-pane"]').tab('show')
    } else if(activeProject.isAluminum) {
        button = document.getElementById('aluminum-material-tab')
        $('a[href="#aluminum-material-tab-pane"]').tab('show')
    }
    if(button) {
        toggleMaterialButtons(button)
    }
    $('#modal-material-selector-dialog').modal('show');
}

function toggleMaterialButtons(button) {
    const buttonIds = [
        'steel-material-tab',
        'european-steel-material-tab',
        'astm-steel-material-tab',
        'wood-material-tab',
        'aluminum-material-tab'
    ]
    buttonIds.forEach( id => document.getElementById(id).className = 'btn btn-default button-shadow')
    if(button) { button.classList.add('btn-primary') }
}

function clearMaterialTableSelection() {
    const tableIds = [
        'steel-material-table',
        'astm-steel-material-table',
        'european-steel-material-table',
        'wood-material-accordion',
        'aluminum-material-table'
    ]

    tableIds.forEach( id => {
        let rows = document.getElementById(id).getElementsByTagName('tr')
        for (let i = 1; i < rows.length; i++) {
            rows[i].classList.remove('material-table-row-selected')
        }
    })
}

function _initMetalMaterialTable(materialJson, tableId, eventName) {
    const materials = materialJson

    let str = "<table class='table material-table'>"
    str += '<thead><tr><th>Name</th><th>Fy (ksi)</th><th>Elastic Modulus (ksi)</th></tr></thead>'

    for(let m in materials) {
        str += `<tr><td>${materials[m].Name}</td><td>${materials[m].Fy}</td><td>${materials[m].E}</td></tr>`
    }
    str += '</table>'

    const table = document.getElementById(tableId)
    table.innerHTML = str

    const rows = table.getElementsByTagName("tr")
    for (let i = 1; i < rows.length; i++) {
        rows[i].onclick = function() {
            clearMaterialTableSelection()
            rows[i].classList.add('material-table-row-selected')
            $('#modal-material-selector-dialog').trigger(eventName, materials[i-1])
            $('#modal-material-selector-dialog').modal('toggle')
        }
    }
}

function initSteelTable() {
    _initMetalMaterialTable(steelMaterialJson, 'steel-material-table', 'north-american-steel-material-selected')
}

function initEuropeanSteelTable() {
    _initMetalMaterialTable(europeanSteelMaterialJson, 'european-steel-material-table', 'european-steel-material-selected')
}

function initASTMSteelTable() {
    _initMetalMaterialTable(astmSteelMaterialJson, 'astm-steel-material-table', 'astm-steel-material-selected')
}

function initAluminumTable() {
    _initMetalMaterialTable(aluminumMaterialJson, 'aluminum-material-table', 'aluminum-material-selected')
}